import React from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowUp, ArrowDown } from 'react-bootstrap-icons';
import PrimaryButton from '../buttons/PrimaryButton';
import { MobileFloatingActionBarProps } from '../../types/priceTypes';

const MobileFloatingActionBar: React.FC<MobileFloatingActionBarProps> = ({
  triggeredFromTask,
  allTaskPricesRecorded,
  addAggregatePresentationsCount,
  formPosition,
  finishRegistration,
  scrollToPriceRecordForm,
}) => {
  const { t } = useTranslation('price');

  const showFinishRegistrationBar = !triggeredFromTask || allTaskPricesRecorded;
  const showScrollInstructionBar =
    triggeredFromTask && !allTaskPricesRecorded && formPosition !== 'inView';

  return (
    <>
      {/* Floating Bottom Bar for Mobile: Finish Registration */}
      {showFinishRegistrationBar && (
        <div className="fixed bottom-4 left-4 right-4 z-50 rounded-xl border border-blue-200 bg-white/95 p-3 shadow-2xl backdrop-blur-md transition-all xl:hidden">
          <PrimaryButton
            handleOnClick={finishRegistration}
            width="100%"
            height="40px"
            hideBgGradient={true}
            disabled={
              triggeredFromTask
                ? !allTaskPricesRecorded || addAggregatePresentationsCount === 0
                : addAggregatePresentationsCount === 0
            }
            className="flex items-center justify-center shadow-md"
          >
            {t('finishRegistration')}
          </PrimaryButton>
        </div>
      )}

      {/* Floating Bottom Instruction Bar for Mobile: Scroll Instruction */}
      {showScrollInstructionBar && (
        <div
          onClick={scrollToPriceRecordForm}
          className="fixed bottom-4 left-4 right-4 z-50 flex cursor-pointer items-center justify-between gap-3 rounded-xl border border-blue-200 bg-blue-600/95 p-3 text-white shadow-2xl backdrop-blur-md transition-all hover:bg-blue-700 active:scale-[0.99] xl:hidden"
        >
          <span className="text-xs font-semibold sm:text-sm">
            {formPosition === 'above' ? t('scrollUpInstruction') : t('scrollDownInstruction')}
          </span>
          <div className="flex h-9 w-9 min-w-[36px] shrink-0 items-center justify-center rounded-full border border-white/40 bg-white/25 text-white shadow-md transition-all hover:bg-white/40 active:scale-90">
            {formPosition === 'above' ? (
              <ArrowUp className="h-4 w-4 text-white" />
            ) : (
              <ArrowDown className="h-4 w-4 text-white" />
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default MobileFloatingActionBar;
